export default __webpack_public_path__ + "atomic/_patterns/03-organisms/block-in-paragraph/_block-in-paragraph.twig";